import React, { useEffect } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import "./App.css";

import DocumentDetails from "./components/documents/DocumentDetails";
import SelectFacilityWidget from "./components/SelectFacilityWidget";
import FacilityDetails from "./components/facilities/FacilityDetails";
import UploadDocuments from "./components/UploadDocuments";
import MyFacilities from "./components/facilities/MyFacilities";
import MyDocuments from "./components/documents/MyDocuments";
import Navbar from "./components/Navbar";
import Login from "./components/Login";
import Register from "./components/Register";
import Home from "./components/Home";
import Profile from "./components/Profile";
import Dashboard from "./components/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import { getCurrentUser } from "./app/actions/auth";
export { App };

function App() {
  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCurrentUser());
  }, []);
  return (
    <div className="App">
      <Navbar />

      <div className="main-container mt-3">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route
            element={
              <Container maxWidth="sm">
                <Box
                  sx={{
                    "& .MuiTextField-root": { m: 1, width: "25ch" },
                  }}
                >
                  <Outlet />{" "}
                </Box>
              </Container>
            }
          >
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
          </Route>

          <Route element={<ProtectedRoute />}>
            <Route element={<SelectFacilityWidget />}>
              <Route path="/profile" element={<Profile />} />
              <Route path="/upload-document" element={<UploadDocuments />} />
              <Route path="/my-facilities" element={<MyFacilities />} />
              <Route path="/my-documents" element={<MyDocuments />} />

              <Route path="/dashboard" element={<Dashboard />} />
            </Route>
            <Route
              path="/document/:document_id"
              element={<DocumentDetails />}
            />
            <Route
              path="/facility/:facility_id"
              element={<FacilityDetails />}
            />
            <Route path="/add-facility" element={<FacilityDetails />} />
          </Route>
        </Routes>
      </div>
    </div>
  );
}
